import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Shared
  Close: 'Close',
  Save: 'Save',
  Remark: 'Remark',
  Reference: 'Reference',
  ProfessionalUsePercentage: 'Professional use %',
  VatDeductionPercentage: 'VAT deduction %',
  PurchaseOptionPercentage: 'Purchase option %',
  TaxDeductionPercentage: 'Tax deduction %',
  EndUserRelation: 'End user / relation',
  NewRelation: 'New relation',
  FiscalRealEstate: 'Real estate',

  // Vehicle
  AddFiscalVehicle: 'Add fiscal vehicle',
  FiscalVehicle: 'Fiscal vehicle',
  VehicleType: 'Vehicle type',
  BrandAndModel: 'Brand and model',
  FuelType: 'Fuel type',
  PurchaseDate: 'Purchase date',
  FirstRegistrationDate: 'First registration date',
  SaleDate: 'Sale date',
  LicensePlate: 'License plate',
  ChassisNumber: 'Chassis number',
  FuelCard: 'Fuel card',
  CO2: 'CO2',
  CO2WLTP: 'CO2 WLTP',
  CatalogValue: 'Catalog value',
  PurchaseValue: 'Purchase value',
  Driver: 'Driver',
  VehicleFunding: 'Funding',
  FundingCompany: 'Funding company',
  VehicleExtractionInfo:
    'You can upload and automatically extract vehicle data from documents such as DIV registrations, vehicle tax documents, registration certificates, vehicle invoices, and certificates of conformity.',

  // Loan
  AddFiscalLoan: 'Add fiscal loan',
  FiscalLoan: 'Fiscal loan',
  LoanType: 'Loan type',
  CreditInstitution: 'Credit institution',
  StartDate: 'Start date',
  EndDate: 'End date',
  Purpose: 'Purpose',
  Amount: 'Amount',
  RepaymentAmount: 'Repayment amount',
  RepaymentMonths: 'Repayment months',
  LoanExtractionInfo:
    'You can upload and automatically extract loan data from documents such as contracts, loan contracts, leasing/renting contracts, and repayment tables.',

  // Insurance
  AddFiscalInsurance: 'Add fiscal insurance',
  FiscalInsurance: 'Fiscal insurance',
  InsuranceType: 'Insurance type',
  InsuranceCompany: 'Insurance company',
  Date: 'Date',

  // Cost
  AddFiscalCost: 'Add fiscal cost',
  FiscalCost: 'Fiscal cost',
  FiscalCostType: 'Cost type',

  // Real Estate
  AddFiscalRealEstate: 'Add real estate',
  Address: 'Address',
  Country: 'Country',
  ParcelNumber: 'Parcel number',
  Owners: 'Owners',
  FiscalRealEstateType: 'Real estate type',
  OwnershipType: 'Ownership type',
  CadastralIncome: 'Cadastral income',
  MonthlyRent: 'Monthly rent',
  LeaseholdEstateEndDate: 'Leasehold estate end date',
  DateOfFirstUse: 'Date of first use',
  RealEstateExtractionInfo:
    'You can upload and automatically extract real estate data from documents such as rental agreements and real estate documents.',
  RealEstateExtractionNoParcelMatch:
    'The extracted data does not contain a real estate matching the current parcel number.',
});

export default messages;
